<template>
  <div>
    <transition name="fade">
      <div class="mainMenuButtonContainer" v-show="this.isShowMainMenuButton" @mouseup.prevent="openMainMenu">
        <img class="mainMenuButton touch" src="../assets/images/menu/mainMenu.png"/>
      </div>
    </transition>
    <transition name="fade">
      <div class="speakerButtonContainer">
        <img class="speakerButton touch" v-show="!this.isSpeakerMuted && this.isShowMainMenuButton" src="../assets/images/menu/speakerOn.png" @mouseup.prevent="turnOffSpeaker"/>
        <img class="speakerButton touch" v-show="this.isSpeakerMuted && this.isShowMainMenuButton" src="../assets/images/menu/speakerOff.png" @mouseup.prevent="turnOnSpeaker"/>
      </div>
    </transition>


    <transition name="fade">
      <div id="mainMenu" class="mainMenu" v-show="this.isShowMainMenu">
        <img class="bg bgRatio" src="~@/../src/assets/images/journey/firstFrame.jpg">
        <div class="bgCover"></div>

        <div class="flowerTopArea">
          <img class="areaElement touch" src="~@/../src/assets/images/mainMenu/flowerTop.png" >
        </div>
        <div class="enArea touch" @mouseup.prevent="changeToEn">
          <img class="halfAreaElement" src="~@/../src/assets/images/mainMenu/EN.png" >
        </div>
        <div class="tcArea touch" @mouseup.prevent="changeToTc">
          <img class="halfAreaElement" src="~@/../src/assets/images/mainMenu/TC.png" >
        </div>
        <div class="selectedENArea" v-if="this.language == 'EN'"></div>  
        <div class="selectedTCArea" v-if="this.language == 'TC'"></div>        
        <div class="breakLineTop"></div>
        <div class="playIGArea">
          <img class="areaElement touch" v-if="this.language == 'TC'" src="~@/../src/assets/images/mainMenu/playIGTC.png" @mouseup.prevent="openIg" @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openIg">
          <img class="areaElement touch" v-if="this.language == 'EN'" src="~@/../src/assets/images/mainMenu/playIGEN.png" @mouseup.prevent="openIg" @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openIg">
        </div>
        <div class="breakLineCenterTop"></div>
        <div class="exhibitionArea">
          <img class="areaElement touch" v-if="this.language == 'TC'" src="~@/../src/assets/images/mainMenu/exhibitionTC.png" @mouseup.prevent="openExhibition" @mousedown.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openExhibition">
          <img class="areaElement touch" v-if="this.language == 'EN'" src="~@/../src/assets/images/mainMenu/exhibitionEn.png" @mouseup.prevent="openExhibition" @mousedown.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openExhibition">
        </div>
        <div class="breakLineCenterBottom"></div>
        <div class="ticketArea">
          <img class="areaElement touch" v-if="this.language == 'TC'" src="~@/../src/assets/images/mainMenu/ticketTC.png" @mouseup.prevent="openTicketing" @mousedown.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openTicketing">
          <img class="areaElement touch" v-if="this.language == 'EN'" src="~@/../src/assets/images/mainMenu/ticketEN.png" @mouseup.prevent="openTicketing" @mousedown.prevent=""
                                          @touchstart.prevent=""
                                          @touchmove.prevent=""
                                          @touchend.prevent="openTicketing">
        </div>
        <div class="breakLineBottom"></div>
        <div class="flowerBottomArea">
          <img class="areaElement" src="~@/../src/assets/images/mainMenu/flowerBottom.png">
        </div>
        <img class="disneyLogo" :src="this.logo"/>
      </div>
      
    </transition>

    <transition name="fade">
      <div class="mainMenuButtonContainer" v-show="this.isShowMainMenu" @mouseup.prevent="closeMainMenu">
        <img class="mainMenuSubButton touch" src="../assets/images/menu/close.png"/>
      </div>
    </transition>



  </div>
</template>
<script>

import i18n from '@/language';
import { store } from '../store';
import base64Logo from '@/assets/images/base64/logo.js';
import * as commonFunction from '@/commonFunction/commonFunction'


export default {
  name: 'mainMenu',
  components: {
  },
  data () {
    return {
      language : i18n.locale,
      isShowMainMenu : false,
      isSpeakerMuted : false,
      isShowMainMenuButton : false,
      logo : base64Logo.data,
    }
  },
  created(){

    if(commonFunction.isIOSwithChrome()){
      setTimeout(function(){
        var style = document.getElementById("mainMenu").getAttribute("style");
        if(style != null){
          var addStyle = style + "height:" + window.innerHeight + "px;";
        }
        else{
          var addStyle = "height:" + window.innerHeight + "px;";
        }
        document.getElementById("mainMenu").setAttribute("style",addStyle);
      },1000)
    }
  },
  methods:{
    turnOnSpeaker(){
      store.state.isMuted = false;
      gtag('event', 'Main Menu Speaker On Btn',{
        'send_to': 'G-LPYZD9LDDW'
      });
    },

    turnOffSpeaker(){
      store.state.isMuted = true;
      gtag('event', 'Main Menu Speaker Off Btn',{
        'send_to': 'G-LPYZD9LDDW'
      });
    },

    changeToEn(){
      i18n.locale = 'EN';
      gtag('event', 'Main Menu Set Lang EN',{
        'send_to': 'G-LPYZD9LDDW'
      });
    },

    changeToTc(){
      i18n.locale = 'TC';
      gtag('event', 'Main Menu Set Lang TC',{
        'send_to': 'G-LPYZD9LDDW'
      });
    },

    openMainMenu(){
      store.state.isShowMainMenu = true;
      gtag('event', 'Open burger menu',{
        'send_to': 'G-LPYZD9LDDW'
      });
    },

    closeMainMenu(){
      store.state.isShowMainMenu = false;
      gtag('event', 'Close burger menu',{
        'send_to': 'G-LPYZD9LDDW'
      });
    },
    openIg(){
      gtag('event', 'Main Menu IG Filter Btn',{
        'send_to': 'G-LPYZD9LDDW'
      });
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk006+standard'
      });
      window.open(store.state.igURL, "_blank"); 
    },
    openExhibition(){
      gtag('event', 'Main Menu Exhibition Btn',{
        'send_to': 'G-LPYZD9LDDW'
      });
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk00e+standard'
      });
      window.open(this.$t('exhibitionURL'), "_blank"); 
    },
    openTicketing(){
      gtag('event', 'Main Menu Ticketing Btn',{
        'send_to': 'G-LPYZD9LDDW'
      });
      gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-8227103/15tha0/pi_hk007+standard'
      });
      // var urlPath = "";
      // if(window.location.href.includes("/zh-hk")){
      //   urlPath = store.state.ticketingURL + "zh-hk/" + store.state.ticketingURLPath;
      // }else if(window.location.href.includes("/zh-cn")){
      //   urlPath = store.state.ticketingURL + "zh-cn/" + store.state.ticketingURLPath;
      // }else {
      //   urlPath = store.state.ticketingURL  + store.state.ticketingURLPath;
      // }
      window.open(this.$t('ticketingURL'), "_blank"); 
    }
  },

  computed:{
    checkCurrentLanguage(){return i18n.locale;},
    checkIsShowMainMenu(){return store.state.isShowMainMenu},
    checkIsSpeakerMuted(){return store.state.isMuted},
    checkIsShowMainMenuButton(){return store.state.isShowMainMenuButton},
  },
  watch:{
    checkCurrentLanguage(lang){this.language = lang;},
    checkIsShowMainMenu(isShowMainMenu){this.isShowMainMenu = isShowMainMenu},
    checkIsSpeakerMuted(isMuted){
      this.isSpeakerMuted = isMuted;
      if(isMuted){
        store.audioElement.muted = true;
      }else{
        store.audioElement.muted = false;
      }
    },
    checkIsShowMainMenuButton(isShowMainMenuButton){this.isShowMainMenuButton = isShowMainMenuButton},
  },
}


</script>

<style scoped>

  .mainMenu{
    position: fixed;
    top: 0%;
    left: 0%;
    width: 100%;
    height: calc(100% + 5px);
  }

  .disneyLogo{
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translate3d(-50%,0,0);
    width: 120px;
    height: auto;
  }
  .mainMenuButtonContainer{
    position: absolute;
    top: 20px;
    right: 10px;
    width: 36px;
    height: 36px;
  }
  .mainMenuButton{
    width: 100%;
    margin-bottom: 10px;
  }

  .speakerButtonContainer{
    position: absolute;
    top: 76px;
    right: 10px;
    width: 36px;
    height: 36px;
  }

  .speakerButton{
    width: 100%;
    margin-bottom: 10px;
  }

  .mainMenuSubButton{
    width: 80%;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
    margin-bottom: 10px;
  }
  
  .mainMenu{
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: calc(100% + 5px);
    background-color: rgba(33,55,103,0.93);
  }

  .bg{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
  }

  @media (max-aspect-ratio: 1728 / 1080){.bgRatio{min-width: 100%;max-height: 100%}}
  @media (min-aspect-ratio: 1728 / 1080){.bgRatio{max-width: 100%;min-height: 100%}}

  .bgCover{
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: calc(100% + 5px);
    background-color: rgba(33,55,103,0.93);
  }

  .flowerTopArea{
    position: absolute;
    top: calc(50% - 4% - 4% - 4% - 4% - 4% - 4% - 4% - 4%);
    width: 100%;
    height: 4%;
  }

  .tcArea{
    position: absolute;
    top: calc(50% - 4% - 4% - 4% - 4% - 4% - 3.5%);
    width: 50%;
    height: 6.5%;
    left: 50%;
  }

  .enArea{
    position: absolute;
    top: calc(50% - 4% - 4% - 4% - 4% - 4% - 3.5%);
    width: 50%;
    height: 6.5%;
  }


  .selectedENArea{
    position: absolute;
    top: calc(50% - 4% - 4% - 4% - 4% - 0.4%);
    width: 50%;
    height: 4px;
    background-color: rgba(238,213,181,1);
  }
  .selectedTCArea{
    position: absolute;
    top: calc(50% - 4% - 4% - 4% - 4% - 0.4%);
    width: 50%;
    height: 4px;
    left : 50%;
    background-color: rgba(238,213,181,1);
  }
  

  

  

  .areaElement{
    position: absolute;
    height: 100%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .halfAreaElement{
    position: absolute;
    top: calc(20%);
    height: 40%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .breakLineTop{
    position: absolute;
    top: calc(50% - 4% - 4% - 4% - 4%);
    width: 100%;
    height: 2px;
    background-color: rgba(255,255,255,0.2);
  }
  

  .playIGArea{
    position: absolute;
    top: calc(50% - 4% - 4% - 4%);
    width: 100%;
    height: 4%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .breakLineCenterTop{
    position: absolute;
    width: 100%;
    top: calc(50% - 4%);
    height: 2px;
    background-color: rgba(255,255,255,0.2);
  }

  .exhibitionArea{
    position: absolute;
    top: 50%;
    width: 100%;
    height: 4%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .breakLineCenterBottom{
    position: absolute;
    width: 100%;
    top: calc(50% + 4% + 4%);
    height: 2px;
    background-color: rgba(255,255,255,0.2);
  }

  .ticketArea{
    position: absolute;
    top: calc(50% + 4% + 4% + 4.5%);
    width: 100%;
    height: 4%;
    left: 50%;
    transform: translate3d(-50%,0,0);
  }

  .breakLineBottom{
    position: absolute;
    top: calc(50% + 4.5% + 4% + 4% + 4% + 4%);
    width: 100%;
    height: 2px;
    background-color: rgba(255,255,255,0.2);
  }

  .flowerBottomArea{
    position: absolute;
    top: calc(50% + 4.5% + 4% + 4% + 4% + 4% + 4%);
    width: 100%;
    height: 4%;
  }





</style>



// WEBPACK FOOTER //
// src/components/mainMenu.vue